import { useQuery } from '@tanstack/react-query';
import { useGetCurrentBoardId } from 'entities/user/api/hooks/useGetCurrentBoardId';
import { getDocuments } from '../requests';
import type { GetDocumentsRequestType } from '../types';
import { queryKey } from './query-key';

export type UseGetDocumentsParams = Omit<GetDocumentsRequestType, 'boardId'>;

export type UseGetDocumentsOptions = {
  refetchInterval?: number | false;
  refetchIntervalInBackground?: boolean;
};

export const useGetDocuments = (
  params: UseGetDocumentsParams,
  options: UseGetDocumentsOptions = {},
) => {
  const currentBoardId = useGetCurrentBoardId();

  // A request is "self-anchoring" when it already targets concrete documents
  // or a package — authorization is by user_id, not board, so scoping it to the
  // current board would wrongly drop documents that live on another board.
  const hasAnchor = Boolean(
    (params.documentIds && params.documentIds.length > 0) ||
      params.documents ||
      params.packageId,
  );

  const boardId = hasAnchor ? undefined : currentBoardId;

  const queryParams: GetDocumentsRequestType = {
    ...params,
    ...(boardId ? { boardId } : {}),
  };

  return useQuery({
    queryKey: queryKey.documents(queryParams),
    queryFn: () => getDocuments(queryParams),
    enabled: hasAnchor ? true : !!boardId,
    ...options,
  });
};
